function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgUser = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA726"
    },
    d: "M 17 21 C 17 23.761719 14.761719 26 12 26 C 9.238281 26 7 23.761719 7 21 C 7 18.238281 9.238281 16 12 16 C 14.761719 16 17 18.238281 17 21 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M 2 34.699219 C 2 34.699219 4.800781 28.398438 12 28.398438 C 19.199219 28.398438 22 34.699219 22 34.699219 L 22 38 L 2 38 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M 46 34.699219 C 46 34.699219 43.199219 28.398438 36 28.398438 C 28.800781 28.398438 26 34.699219 26 34.699219 L 26 38 L 46 38 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB74D"
    },
    d: "M 30 17 C 30 20.3125 27.3125 23 24 23 C 20.6875 23 18 20.3125 18 17 C 18 13.6875 20.6875 11 24 11 C 27.3125 11 30 13.6875 30 17 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M 36 34.101563 C 36 34.101563 32.699219 26.601563 24 26.601563 C 15.300781 26.601563 12 34.101563 12 34.101563 L 12 38 L 36 38 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA726"
    },
    d: "M 41 21 C 41 23.761719 38.761719 26 36 26 C 33.238281 26 31 23.761719 31 21 C 31 18.238281 33.238281 16 36 16 C 38.761719 16 41 18.238281 41 21 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA726"
    },
    d: "M 17 21 C 17 23.761719 14.761719 26 12 26 C 9.238281 26 7 23.761719 7 21 C 7 18.238281 9.238281 16 12 16 C 14.761719 16 17 18.238281 17 21 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA726"
    },
    d: "M 41 21 C 41 23.761719 38.761719 26 36 26 C 33.238281 26 31 23.761719 31 21 C 31 18.238281 33.238281 16 36 16 C 38.761719 16 41 18.238281 41 21 Z "
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.3ea3e98a.svg";
export { ForwardRef as ReactComponent };